import graphql from './graphql';

const query = /* GraphQL */ `
  query makeSignedUrl($key: String, $command: String) {
    makeSignedUrl(key: $key, command: $command) {
      signedUrl
    }
  }
`;

const S3makeSignedUrl = async ({ key, command }) =>
  graphql(query, { key, command }).then(({ makeSignedUrl }) => makeSignedUrl);

export default S3makeSignedUrl;
